import { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { usePatientProfile } from '../ProfileBar/hooks';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { normalizeAustralianMobileNumber04OrPlus614 } from '../../pages/MyAccount/utils/numberUtils';
import { LoadingSpinner } from '../LoadingSpinner';

import loopArrowsIcon from '../../../assets/img/loop-arrows.png';
import cellPhoneIcon from '../../../assets/img/cell-phone.png';

interface Props {
  activeTitle: string;
  description: string;
  buttonName?: string;
  numberFieldTitle?: string;
  onInvitePatient: (phoneNumber: string) => void;
  loading?: boolean;
  sent?: boolean;
  showButton: boolean;
  showTextField?: boolean;
  direction?: 'column' | 'row';
}
export const PatientAppInviteCard = ({
  sent,
  onInvitePatient,
  loading,
  description,
  activeTitle,
  buttonName,
  numberFieldTitle,
  showButton,
  showTextField = true,
  direction = 'column',
}: Props) => {
  const { patientProfile } = usePatientProfile();
  const [phone, setPhone] = useState<string>(
    normalizeAustralianMobileNumber04OrPlus614(patientProfile.phone || '') ||
      patientProfile.phone ||
      '',
  );
  const [phoneError, setPhoneError] = useState<string | null>(null);

  const handleInvite = () => {
    if (!showTextField) {
      setPhoneError(null);
      onInvitePatient(phone);
      return;
    }

    const normalized = normalizeAustralianMobileNumber04OrPlus614(phone);
    if (!normalized) {
      setPhoneError('Phone number must start with 04 or +614');
      return;
    }
    setPhoneError(null);
    setPhone(normalized);
    onInvitePatient(normalized);
  };

  return (
    <div className="specialInfoBlock mt-4 mb-1">
      {direction === 'row' ? (
        <Row className="g-1 align-items-center">
          <Col xs={12} md={showButton ? 5 : 12}>
            <Row className="g-1">
              <div className="txtDescription">
                <img src={loopArrowsIcon} alt=""></img>
                <span className="font-weight-600">{activeTitle}</span>
              </div>
              {description && <p>{description}</p>}
            </Row>
          </Col>
          {showButton && <Col xs={0} md={1} />}
          {showButton && (
            <Col xs={12} md={5}>
              {sent ? (
                <Row className="mt-3">
                  <button className="btn d-flex flex-row gap-2 consumer-created align-items-center justify-content-center">
                    <span className="font-weight-600 font-14 color-white">
                      Sent
                    </span>
                    <CheckCircleFill color="#fff" size={16} />
                  </button>
                </Row>
              ) : (
                <>
                  {showTextField && (
                    <Row>
                      <div>{numberFieldTitle}</div>
                      <Form.Control
                        type="text"
                        placeholder="Phone number"
                        onChange={(e) => {
                          setPhone(e.target.value);
                          setPhoneError(null);
                        }}
                        disabled={loading}
                        value={phone}
                        isInvalid={Boolean(phoneError)}
                      />
                      {phoneError ? (
                        <Form.Control.Feedback type="invalid">
                          {phoneError}
                        </Form.Control.Feedback>
                      ) : null}
                    </Row>
                  )}
                  <Row className="mt-3">
                    <button
                      className="btn btnPrimary btnPrimaryDark btn-long btn-sm d-flex align-items-center justify-content-center gap-2"
                      onClick={handleInvite}
                      disabled={loading}
                      type="button"
                    >
                      {loading ? (
                        <LoadingSpinner size={16} color="primary" showText="" />
                      ) : (
                        <img className="mr-15" src={cellPhoneIcon} alt="" />
                      )}
                      {buttonName}
                    </button>
                  </Row>
                </>
              )}
            </Col>
          )}
        </Row>
      ) : (
        <>
          <Row className="g-1">
            <div className="txtDescription">
              <img src={loopArrowsIcon} alt=""></img>
              <span className="font-weight-600">{activeTitle}</span>
            </div>
            {description && <p>{description}</p>}
          </Row>
          {showButton && (
            <>
              {sent ? (
                <Row className="mt-3">
                  <button className="btn d-flex flex-row gap-2 consumer-created align-items-center justify-content-center">
                    <span className="font-weight-600 font-14 color-white">
                      Sent
                    </span>
                    <CheckCircleFill color="#fff" size={16} />
                  </button>
                </Row>
              ) : (
                <>
                  {showTextField && (
                    <Row>
                      <div>{numberFieldTitle}</div>
                      <Form.Control
                        type="text"
                        placeholder="Phone number"
                        onChange={(e) => {
                          setPhone(e.target.value);
                          setPhoneError(null);
                        }}
                        disabled={loading}
                        value={phone}
                        isInvalid={Boolean(phoneError)}
                      />
                      {phoneError ? (
                        <Form.Control.Feedback type="invalid">
                          {phoneError}
                        </Form.Control.Feedback>
                      ) : null}
                    </Row>
                  )}
                  <Row className="mt-3">
                    <button
                      className="btn btnPrimary btnPrimaryDark btn-long btn-sm d-flex align-items-center justify-content-center gap-2"
                      onClick={handleInvite}
                      disabled={loading}
                      type="button"
                    >
                      {loading ? (
                        <LoadingSpinner size={16} color="primary" showText="" />
                      ) : (
                        <img className="mr-15" src={cellPhoneIcon} alt="" />
                      )}
                      {buttonName}
                    </button>
                  </Row>
                </>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
